export enum StatusType {
  USER,
  REMITTER,
  BENEFICIARY,
  ADDITIONAL_FILE_REQUEST,
  KYC_SUBMISSIONS,
  EXCHANGE_RATE,
  SERVICE,
  CURRENCY,
  CMS,
  TRANSACTION,
  FAQ,
  SLIDER,
  VOUCHER,
  VOUCHER_REMITTER,
  ANNOUCEMENT,
}
